module.exports = __webpack_public_path__ + "static/11-15291e6153200e7a473683330574c19a.jpg";